import axios from 'axios'
import { BUSCAR_PRECOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarRotas (codigo, tipoVeiculo, texto) {
  let url
  if (!texto) {
    url = `${URL}/preco/empresa/${codigo}/tipo-veiculo/${tipoVeiculo}/precos`;
  } else url = `${URL}/preco/empresa/${codigo}/tipo-veiculo/${tipoVeiculo}/texto/${texto}/precos`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PRECOS,
        payload: response

      })
  );
}
